import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "includes/Layouts.js";
import { ReactComponent as FacebookIcon } from "./../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "./../images/twitter-icon.svg";

const Container = tw(ContainerBase)`bg-gray-900 text-gray-100  `;
const Content = tw.div`max-w-screen-xl mx-auto py-20  `;

const Row = tw.div`flex items-center justify-center flex-col `;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`;
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`;
export default class Footer extends React.Component {
  logo;
  info;
  footer_tile;
  footer_info;
  footer_text;
  footer_menus = [];

  constructor(prop) {
    super(prop);
    this.logo = prop.footerData.logo;
    this.info = prop.footerData.info;
    this.footer_tile = prop.footerData.heading_tile;
    this.footer_info = prop.footerData.heading_info;
    this.footer_text = prop.footerData.footer_text;
    this.footer_menus = prop.footerData.footer_menus;
  }

  render() {
    return (
      <Container className="footer">
        <Content>
          <Row>
            <LogoContainer>
              <LogoImg src={this.info.website_logo} />
              <LogoText>
                {this.footer_tile} {this.footer_info}
              </LogoText>
            </LogoContainer>
            <LinksContainer>
              {this.footer_menus.map((menu, i) => (
                <Link
                  key={i}
                  href={menu.slug !== "home" ? "/" + menu.slug : "/"}
                >
                  {menu.name}
                </Link>
              ))}
            </LinksContainer>
            <SocialLinksContainer>
              <SocialLink href={this.info.social_facebook} target="_blank">
                <FacebookIcon />
              </SocialLink>
              <SocialLink href={this.info.social_twitter} target="_blank">
                <TwitterIcon />
              </SocialLink>
            </SocialLinksContainer>
            <br/>
              <img className="img-responsive" style={{ cursor: 'pointer' }} alt="SiteLock" onClick={ () => {window.open('https://www.sitelock.com/verify.php?site=kellystaxi.com','SiteLock','width=600,height=600,left=160,top=170')}} title="SiteLock" src="//shield.sitelock.com/shield/kellystaxi.com"/>
            <CopyrightText>{this.info.website_footer_text}</CopyrightText>
          </Row>
        </Content>
      </Container>
    );
  }
}
